export default "__VITE_PUBLIC_ASSET__e57f6fd5__"